import { useMemo } from 'react';
import { AppState } from 'state';
import { useAppSelector } from 'state/hooks';

import { PhoneboothScreenState, ScreenCursorState } from './slice';

export function usePhoneboothState(): PhoneboothScreenState {
  const state = useAppSelector((s: AppState) => s.phonebooth.state);
  return useMemo(() => state, [state]);
}

export function useScreenCursorState(): ScreenCursorState {
  const cursorState = useAppSelector((s: AppState) => s.phonebooth.cursor);
  return useMemo(() => cursorState, [cursorState]);
}
